import React from 'react';

const ColumnHeader = ({ className, ...props }) => (
  <span className="ContentPerformanceFigure" {...props} />
);

const ContentPerformanceFiguresHeader = ({ children, features }) => (
  <div className="ContentPerformanceFigures ContentPerformanceFigures--header">
    <ColumnHeader>Total Complete</ColumnHeader>
    <ColumnHeader>Average Score</ColumnHeader>
  </div>
);

export default ContentPerformanceFiguresHeader;
